import React, { useEffect, useRef, useState } from "react";
import { useInView, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function AnimatedCounter({ value = 0, suffix = "", prefix = "", decimals = 0, duration = 1.6, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const motion = useMotionValue(0);
  const spring = useSpring(motion, { stiffness: 70, damping: 22, mass: 0.6, duration });
  const rounded = useTransform(spring, (v) => v.toFixed(decimals));
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    const unsub = rounded.on("change", (latest) => setDisplay(latest));
    return () => unsub();
  }, [rounded]);

  useEffect(() => {
    if (inView) motion.set(value);
  }, [inView, motion, value]);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
}
